import { render, staticRenderFns } from "./dailyRegistration.vue?vue&type=template&id=5019c5ce&scoped=true&"
import script from "./dailyRegistration.vue?vue&type=script&lang=js&"
export * from "./dailyRegistration.vue?vue&type=script&lang=js&"
import style0 from "./dailyRegistration.vue?vue&type=style&index=0&id=5019c5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019c5ce",
  null
  
)

export default component.exports